// Author YuJiaBei
// Date 2020-08-07 15:55:23

class EmLcScrReasonSrea {
constructor({
        id = null,
        sreaName = '',
        sreaDescription = ''}
= {}) {
    this.id = id;
    this.sreaName = sreaName;
    this.sreaDescription = sreaDescription;
}
}

function newEntity() {
return new EmLcScrReasonSrea();
}

function gridFields() {
return Object.freeze([
        {
        key: 'sreaName',
        label: 'label.em.lifecycle.emLcScrReasonSrea.grid.sreaName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sreaDescription',
        label: 'label.em.lifecycle.emLcScrReasonSrea.grid.sreaDescription',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
]);
}

const filter = {
    sreaNameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'sreaNameFilter',
        label: 'label.em.lifecycle.emLcScrReasonSrea.filter.sreaName',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];

const entityFormConfigs = [
        {
        key: 'sreaName',
        label: 'label.em.lifecycle.emLcScrReasonSrea.entity.sreaName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'sreaDescription',
        label: 'label.em.lifecycle.emLcScrReasonSrea.entity.sreaDescription',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmLcScrReasonSrea, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs , filterConfigs}
